/**
 * Legal document versions.
 *
 * Bump these strings whenever the substantive content of Terms of Service or
 * Privacy Policy changes. The version string is captured into `tos_acceptances`
 * at the moment a user agrees, so we know exactly which contract version each
 * user is bound by, and a bump re-prompts existing families to re-accept.
 *
 * Format: `YYYY-MM-DD` (the date the version became effective). If you ship
 * a corrective edit on the same day, append `-rN` (e.g. `2026-07-05-r2`).
 *
 * 2026-07-05: Full rewrite for the single-academy parent-tuition consumer
 * model (was written for the dead multi-gym B2B SaaS model). DRAFT pending
 * attorney review.
 */

export const TOS_VERSION = "2026-09-27";
export const PRIVACY_VERSION = "2026-07-05";

/**
 * Human-readable "Effective:" labels rendered on the legal pages. Keep in sync
 * with the version dates above; we don't compute these at runtime so the
 * rendered text matches the version string exactly.
 */
export const TOS_EFFECTIVE_LABEL = "September 27, 2026";
export const PRIVACY_EFFECTIVE_LABEL = "July 5, 2026";

export interface AcceptedLegalVersions {
  tosVersion: string;
  privacyVersion: string;
  acceptedAt: string;
}

export function buildAcceptanceRecord(): AcceptedLegalVersions {
  return {
    tosVersion: TOS_VERSION,
    privacyVersion: PRIVACY_VERSION,
    acceptedAt: new Date().toISOString(),
  };
}
